import { prepareUrlParamsForFilterProducts } from '@/utils/api-drive-params'
export default class ProductSearch {
  constructor(http) {
    this.http = http;
  }

  searchPath(shopId, categoryId, keyWords, filterList, page, sortBy) {
    if (filterList || page || sortBy) {
      return prepareUrlParamsForFilterProducts('recherche', keyWords, filterList, page, sortBy, shopId, categoryId)
    } else {
      const paramsQuery = `?query=${keyWords}`
      return `/api/magasins/${shopId}/recherche${paramsQuery}`;
    }
  }

  panachagePath(shopId, idPanachage) {
    return `/api/magasins/${shopId}/panachages/${idPanachage}`;
  }

  async search(params) {
    const response = await this.http.get(this.searchPath(params.shopId, null, encodeURIComponent(params.keyWords), params.filterList, params.page, params.sortBy));
    return response.data;
  }

  async panachage(params) {
    const response = await this.http.get(this.panachagePath(params.shopId), this.panachagePath(params.idPanachage));
    return response.data;
  }
}
